export default function Services() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Home Security Consulting',
      description: 'Expert guidance in selecting the best home considering your budget, location, and security needs.',
      features: ['Budget Analysis', 'Location Assessment', 'Security Evaluation']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Research',
      description: 'Comprehensive market analysis helping businesses thrive in competitive African markets.',
      features: ['Market Analysis', 'Competitor Research', 'Growth Strategy']
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'Asset Sales Platform',
      description: 'Connect buyers to sellers of products including new and used vehicles and other assets.',
      features: ['Vehicle Sales', 'Asset Listing', 'Buyer Matching']
    },
    {
      icon: 'ri-file-text-line',
      title: 'Grant & Proposal Writing',
      description: 'Professional grant writing and proposal development services for funding success.',
      features: ['Grant Applications', 'Proposal Writing', 'Funding Strategy']
    },
    {
      icon: 'ri-team-line',
      title: 'Recruiting Agency',
      description: 'Connecting talented professionals with leading organizations across Africa.',
      features: ['Talent Sourcing', 'Candidate Screening', 'Placement Services']
    }
  ];

  return (
    <section id="services" className="py-20 lg:py-32 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-16">
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900">
              Our Core <span className="text-[#D4AF37]">Services</span>
            </h2>
            <p className="text-gray-600 text-base mt-4">
              Comprehensive solutions tailored for African market dynamics
            </p>
          </div>
          <div className="bg-gray-900 text-white px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap">
            5 Service Categories
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-[#D4AF37] rounded-full mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {service.description}
              </p>

              <div className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <i className="ri-check-line text-[#D4AF37] text-lg"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>

              <button className="text-[#D4AF37] font-semibold text-sm flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap">
                Learn More
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
